<!-- Loading bar -->
@if (loading) {
  <mat-progress-bar class="absolute inset-x-0 top-0 h-0.5" mode="indeterminate">
  </mat-progress-bar>
}

<!-- master-data -->
<div class="flex flex-col flex-auto overflow-y-auto lg:overflow-hidden bg-card dark:bg-default">
  <ng-container *ngTemplateOutlet="databaseViewMode ? databaseView : dataView"></ng-container>
</div>

<!-- Data View -->
<ng-template #dataView>
  <!-- Messages -->
  @if (repo?.dtypeToGoLiveSchedule && showAlerts?.showScheduleToGoLive && !isNew && role?.dataVerifier && !repo.migrating) {
    <div class="flex pl-2 pr-2 items-center w-full bg-amber-100 dark:bg-amber-500">
      <mat-icon class="mat-icon notranslate icon-size-5 mat-icon-no-color mr-2 flex" aria-hidden="true"[svgIcon]="'heroicons_solid:exclamation'"></mat-icon>
      <span class="flex-auto"> {{ scheduleAlert }} </span>
      <button class="flex place-self-end" mat-icon-button matTooltip="{{'close' | transloco}}" (click)="showAlerts.showScheduleToGoLive = false">
        <mat-icon class="mat-icon notranslate icon-size-5 mat-icon-no-color" [svgIcon]="'heroicons_outline:x'"></mat-icon>
      </button>
    </div>
  }
  @if (repo?.dtypeToGoLiveRequest && showAlerts?.showHasRequestToGoLive && !role?.dataVerifier && !isNew && !repo.migrating) {
    <div class="flex pl-2 pr-2 items-center w-full bg-amber-100 dark:bg-amber-500">
      <mat-icon class="mat-icon notranslate icon-size-5 mat-icon-no-color mr-2 flex" aria-hidden="true"[svgIcon]="'heroicons_solid:exclamation'"></mat-icon>
      <span class="flex-auto"> {{ quarantineScheduled.hasRequestMessage }} </span>
      <button class="flex place-self-end" mat-icon-button matTooltip="{{'close' | transloco}}" (click)="showAlerts.showScheduleToGoLive = false">
        <mat-icon class="mat-icon notranslate icon-size-5 mat-icon-no-color" [svgIcon]="'heroicons_outline:x'"></mat-icon>
      </button>
    </div>
  }
  @if (repo?.migrating && showAlerts?.showMigrating && !isNew) {
    <div class="flex pl-2 pr-2 items-center w-full bg-red-100">
      <mat-icon class="mat-icon notranslate icon-size-5 mat-icon-no-color mr-2 flex" aria-hidden="true"[svgIcon]="'heroicons_solid:exclamation'"></mat-icon>
      <span class="flex-auto"> {{ 'quarantineScheduled.migratingMessage' | transloco }} </span>
      <button class="flex place-self-end" mat-icon-button matTooltip="{{'close' | transloco}}" (click)="showAlerts.showScheduleToGoLive = false">
        <mat-icon class="mat-icon notranslate icon-size-5 mat-icon-no-color" [svgIcon]="'heroicons_outline:x'"></mat-icon>
      </button>
    </div>
  }
  <!-- Header -->
  <div class="z-10 relative flex flex-row flex-0 w-full border-b bg-gray-100 dark:bg-transparent">
    <div class="flex flex-col flex-auto items-center justify-start">
      <!-- Go to Buttons -->
      <div class="flex p-4 items-center justify-start w-full">
        <!-- Go back-->
        <a mat-raised-button class="mr-4" [routerLink]="['../']"
                    [queryParams]="{
                        ou: params.ou,
                        marca_code: params.marca_code,
                        cliente_code: params.cliente_code,
                        projectId: params.projectId,
                        serviceId: params.serviceId
                    }">
          <mat-icon class="mat-icon notranslate icon-size-5 mat-icon-no-color" aria-hidden="true"[svgIcon]="'heroicons_solid:external-link'"></mat-icon>
          <span class="pl-1">{{ 'back' | transloco }}</span>
        </a>

        <!-- Go to design -->
        @if (repo && sameLocator && repo.status !== 'STATIC' && !isSystemConfig && hasPermissionToDesignRepository()) {
          <button mat-raised-button class="mr-4"
            [routerLink]="['../design']" [queryParams]="params" [disabled]="repo?.locked && repo?.dtypeToGoLiveRequest">
            <mat-icon class="mat-icon notranslate icon-size-5 mat-icon-no-color" aria-hidden="true"[svgIcon]="'heroicons_solid:external-link'"></mat-icon>
            <span class="pl-1">{{ 'design' | transloco }}</span>
          </button>
        }

        <!-- Go to summary -->
        @if (!isSystemConfig) {
          <button mat-raised-button class="mr-4" [routerLink]="['../summary']" [queryParams]="params">
            <mat-icon class="mat-icon notranslate icon-size-5 mat-icon-no-color" aria-hidden="true"[svgIcon]="'heroicons_solid:external-link'"></mat-icon>
            <span class="pl-1">{{ 'summary' | transloco }}</span>
          </button>
        }

        <!-- Go to BBDD view -->
        @if (!isSystemConfig && role?.dataVerifier) {
          <button mat-raised-button class="mr-4 mat-focus-indicator mat-stroked-button mat-button-base" (click)="changeView()">
            <mat-icon class="mat-icon notranslate icon-size-5 mat-icon-no-color" aria-hidden="true"[svgIcon]="'heroicons_solid:external-link'"></mat-icon>
            <span class="pl-1">{{ 'tableInfo' | transloco }}</span>
          </button>
        }

        <!-- Cancel Quarantine -->
        @if (!isSystemConfig && repo?.status !== 'STATIC' && repo?.dtypeToGoLiveRequest && repo?.locked && repo?.dtypeToGoLiveSchedule && role?.dataVerifier && !repo.migrating) {
          <button
            mat-raised-button class="mr-4 bg-red-600 text-white" (click)="cancelQuarantine()">
            <mat-icon class="mat-icon notranslate icon-size-5 mat-icon-no-color" aria-hidden="true"[svgIcon]="'heroicons_solid:x'"></mat-icon>
            <span class="pl-1">{{ 'quarantineScheduled.cancelLive' | transloco }}</span>
          </button>
        }

      </div>

      <!-- Title -->
      <div class="flex px-6 py-4 font-semibold tracking-tight w-full items-center justify-between">
        <div class="flex items-center gap-2">
          <span class="text-3xl">{{ $safeNavigationMigration(masterData?.caption) | localize }}</span>
          <!-- Icons -->
          @if (!isNew) {
            <!-- Design View -->
            @if (repo?.status === 'DESIGN') {
              <mat-icon class="ml-2" [svgIcon]="'mat_outline:draw'" [ngStyle]="{'color':'orange'}" matTooltip="{{'repositoryIcons.design' | transloco}}"></mat-icon>
            }
            <!-- Live View -->
            @if (repo?.status === 'LIVE') {
              <mat-icon class="ml-2" [svgIcon]="'feather:heart'" [ngStyle]="{'color':'green'}" matTooltip="{{'repositoryIcons.live' | transloco}}"></mat-icon>
            }
            <!-- Static View -->
            @if (repo?.status === 'STATIC') {
              <mat-icon class="ml-2" [svgIcon]="'feather:anchor'" [ngStyle]="{'color':'black'}" matTooltip="{{'repositoryIcons.static' | transloco}}"></mat-icon>
            }
            @if (repo?.status !== 'STATIC') {
              <!-- Locked -->
              @if (repo?.locked) {
                <mat-icon class="ml-2" [svgIcon]="'heroicons_solid:lock-closed'" [ngStyle]="{'color':'red'}" matTooltip="{{'repositoryIcons.locked' | transloco}}"></mat-icon>
              }
              <!-- Unlocked -->
              @if (!repo?.locked) {
                <mat-icon class="ml-2" [svgIcon]="'heroicons_solid:lock-open'" [ngStyle]="{'color':'green'}" matTooltip="{{'repositoryIcons.unlocked' | transloco}}"></mat-icon>
              }
              <!-- Evened -->
              @if (repo?.evened) {
                <mat-icon class="ml-2" [svgIcon]="'heroicons_outline:status-online'" [ngStyle]="{'color':'green'}" matTooltip="{{'repositoryIcons.evened' | transloco}}"></mat-icon>
              }
              <!-- Unevened -->
              @if (!repo?.evened) {
                <mat-icon class="ml-2" [svgIcon]="'heroicons_outline:status-offline'" [ngStyle]="{'color':'orange'}" matTooltip="{{'repositoryIcons.unevened' | transloco}}"></mat-icon>
              }
              <!-- Has Request -->
              @if (repo?.dtypeToGoLiveRequest && !repo?.dtypeToGoLiveSchedule && !repo?.migrating) {
                <mat-icon class="ml-2" [svgIcon]="'mat_outline:note_add'" [ngStyle]="{'color':'orange'}" matTooltip="{{'repositoryIcons.hasRequest' | transloco}}"></mat-icon>
              }
              <!-- Has Schedule -->
              @if (repo?.dtypeToGoLiveSchedule && !repo?.migrating) {
                <mat-icon class="ml-2" [svgIcon]="'feather:clock'" [ngStyle]="{'color':'orange'}" matTooltip="{{'repositoryIcons.hasSchedule' | transloco}}"></mat-icon>
              }
              <!-- Migrating -->
              @if (repo?.migrating) {
                <mat-icon class="ml-2" [svgIcon]="'mat_outline:sync_problem'" [ngStyle]="{'color':'red'}" matTooltip="{{'repositoryIcons.migrating' | transloco}}"></mat-icon>
              }
              <!-- Error Status -->
              @if (repo?.errorStatus === 'ERROR') {
                <mat-icon class="ml-2" [svgIcon]="'mat_outline:error_outline'" [ngStyle]="{'color':'red'}" matTooltip="{{'repositoryIcons.errors' | transloco}}"></mat-icon>
              }
            }
          }
          @if (fileLoading) {
            <fuse-alert
              [appearance]="'outline'"
              [type]="'info'">
              <span fuseAlertTitle>{{ 'fileProcessing' | transloco }}</span>
            </fuse-alert>
          }
        </div>

        <div class="flex items-center gap-4">
          @if (canModifyData && masterData?.isManualOrder) {
            @if (!ordering) {
              <button mat-flat-button (click)="startOrdering()" color="primary">
                <mat-icon class="text-on-primary" [svgIcon]="'mat_outline:swap_vert'"></mat-icon>
                <span class="ml-2">{{ 'orderMaster' | transloco }}</span>
              </button>
            }

            @if (ordering) {
              <button mat-flat-button (click)="cancelOrdering()" color="warn">
                <mat-icon class="text-on-warn" [svgIcon]="'mat_outline:close'"></mat-icon>
                <span class="ml-2">{{ 'cancel' | transloco }}</span>
              </button>
              <button mat-flat-button (click)="saveOrdering()" color="primary">
                <mat-icon class="text-on-primary"  [svgIcon]="'mat_outline:save'"></mat-icon>
                <span class="ml-2">{{ 'save' | transloco }}</span>
              </button>
            }
          }

          @if (canModifyData) {
            @if (!ordering) {
              <button mat-flat-button
                color="accent" [matMenuTriggerFor]="menu">
                <mat-icon class="icon-size-6 text-on-accent" [svgIcon]="'mat_solid:expand_more'"></mat-icon>
                <span class="ml-2 mr-1">{{ 'options' | transloco }}...</span>
              </button>
            }
            <mat-menu #menu="matMenu" class="my-menu">
              <button mat-menu-item (click)="searchCacheRefresh()">
                <mat-icon [svgIcon]="'heroicons_outline:refresh'" class="icon-size-5"></mat-icon>
                <span>{{ 'searchCacheRefresh' | transloco }}</span>
              </button>
              <button mat-menu-item (click)="downloadMaster()">
                <mat-icon [svgIcon]="'mat_outline:download'" class="icon-size-5"></mat-icon>
                <span>{{ 'masterExcelDownload' | transloco }}</span>
              </button>
              @if (!isSystemConfig) {
                <button mat-menu-item (click)="openUploadDialog()">
                  <mat-icon [svgIcon]="'mat_outline:upload'" class="icon-size-5"></mat-icon>
                  <span>{{ 'masterExcelUpload' | transloco }}</span>
                </button>
              }
            </mat-menu>
          }
        </div>
      </div>
    </div>
  </div>

  <!-- Alerts -->
  @if (masterData && masterData.alert.length > 0) {
    <div
      class="flex flex-col w-full py-4 px-8 border-b bg-gray-100 dark:bg-transparent">
      @for (al of masterData.alert; track al) {
        <div class="flex flex-row w-2/5 py-2">
          <fuse-alert [type]="al.type.toLowerCase()" [appearance]="'outline'">
            <span fuseAlertTitle>
              {{ al.type === 'ERROR' ? 'Error' : al.type === 'WARNING' ? ('warning' | transloco) : 'Info' }}
            </span>
            {{ $safeNavigationMigration(al?.text) | localize }}
          </fuse-alert>
        </div>
      }
    </div>
  }

  <!-- Table container -->
  <div class="flex flex-col p-3 bg-gray-100 dark:bg-transparent">
    @if ((visibleItems$ | async); as items) {
      <!-- Table actions -->
      @if (masterData) {
        <div class="flex flex-row items-center mb-4">
          <!-- Search bar -->
          <mat-form-field class="fuse-mat-rounded basis-1/3 justify-center [&_.mat-mdc-form-field-subscript-wrapper]:!hidden">
            <input type="text" matInput [formControl]="searchControl" [placeholder]="'search' | transloco">
            @if (searchControl.value) {
              <button matSuffix mat-icon-button (click)="clearSearch()">
                <mat-icon svgIcon="mat_outline:close"></mat-icon>
              </button>
            }
            <mat-icon matPrefix svgIcon="mat_outline:search"></mat-icon>
          </mat-form-field>
          <button mat-icon-button [class.hidden]="!hasFilter" (click)="toggleFilters()">
            <mat-icon class="icon-size-6"
              [svgIcon]="showFilters ? 'heroicons_solid:filter' : 'heroicons_outline:filter'">
            </mat-icon>
          </button>
          <div class="mr-auto"></div>
          @if (isSystemConfig && uri.includes('SystemChangesForUsers')) {
            <button mat-raised-button color="primary" class="mr-4" (click)="notifySystemChanges()">
              {{ 'notifySystemChanges' | transloco }}
            </button>
          }
          @if (masterData?.validity === 'PERIOD') {
            <div class="flex flex-row">
              <div class="flex items-center text-lg mx-2">
                {{ 'goal.goalValidity' | transloco }}:
              </div>
              <div class="flex items-center" [formGroup]="dateForm">
                @if (dateForm.get('periodsDate').value) {
                  <button mat-icon-button (click)="previousDay()">
                    <mat-icon class="icon-size-8" [svgIcon]="'mat_outline:chevron_left'"></mat-icon>
                  </button>
                }
                @if (dateForm.get('periodsDate').value) {
                  <div class="flex items-center text-lg mx-2">
                    <span>{{ dateForm.get('periodsDate').value | localizeDate: 'dd/MM/yyyy' }}</span>
                    <button mat-icon-button class="ml-2" (click)="clearDate()">
                      <mat-icon [svgIcon]="'mat_outline:close'"></mat-icon>
                    </button>
                  </div>
                }
                <mat-form-field class="w-0 invisible">
                  <input matInput formControlName="periodsDate" [matDatepicker]="picker">
                  <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                  <mat-datepicker #picker></mat-datepicker>
                </mat-form-field>
                <button mat-icon-button (click)="openDatepicker(picker)" class="mr-2">
                  <mat-icon [svgIcon]="'mat_outline:today'" class="icon-size-8"></mat-icon>
                </button>
                @if (dateForm.get('periodsDate').value) {
                  <button mat-icon-button (click)="nextDay()">
                    <mat-icon class="icon-size-8" [svgIcon]="'mat_outline:chevron_right'"></mat-icon>
                  </button>
                }
              </div>
            </div>
          }
          @if (oidsLocationChangePending.length > 0) {
            <mat-slide-toggle [matBadge]="oidsLocationChangePending.length" [(ngModel)]="filterLocationChangePending"
              (change)="toggleLocationChangePending()" class="mr-4" [disabled]="ordering">
              {{ 'showLocationChangePending' | transloco}}
            </mat-slide-toggle>
          }
          <!-- Toggle items -->
          @if (masterData?.validity === 'FLAG') {
            <mat-slide-toggle  [(ngModel)]="includeDeprecated" (change)="deprecatedChanged()" class="mr-4" [disabled]="ordering">
              {{'includeDeprecated' | transloco}}
            </mat-slide-toggle>
          }
          <!-- Toggle items -->
          <mat-slide-toggle [(ngModel)]="compact" class="mr-4">{{'compact' | transloco}}</mat-slide-toggle>
          @if (canModifyData) {
            <!-- Add item -->
            @if (!masterData?.noInsert) {
              <button mat-icon-button (click)="newItem()" [disabled]="ordering">
                <mat-icon svgIcon="mat_outline:add"></mat-icon>
              </button>
            }
            <!-- Remove items -->
            @if (!masterData?.noDelete) {
              <button mat-icon-button [disabled]="!someSelected || ordering" (click)="removeItems()">
                <mat-icon svgIcon="mat_outline:delete"></mat-icon>
              </button>
            }
          }
        </div>
      }
      <dtype-filter [filterDTypeForm]="filterDTypeForm" [showFilters]="showFilters"></dtype-filter>
      <!-- Table -->
      <div class="flex flex-col" fuseScrollReset matSort matSortDisableClear [matSortDisabled]="disabledSort">
        <!-- Header -->
                <div class="flex flex-row gap-4 sticky top-0 px-6 py-4 md:px-8 text-md font-semibold text-secondary
                    shadow bg-gray-50 dark:bg-slate-900 dark:bg-opacity-5">
          @if (canModifyData) {
            <!-- Checkbox column -->
            <div class="flex items-center">
              <mat-checkbox (click)="selectAll($event)" [checked]="allSelected" [disabled]="ordering"
              [indeterminate]="someSelected && !allSelected"></mat-checkbox>
              @if (numSelected !== 0) {
                <p>({{ numSelected }})</p>
              }
            </div>
          }
          <!-- Column names -->
          @for (column of columns; track column) {
            <div class="flex items-center flex-1" [mat-sort-header]="column.name" [disabled]="isSortDisabledForTheColumn(column)">
              {{ column.caption | localize }}
            </div>
          }
          @if (masterData?.typology === 'LOCATION') {
            <div></div>
          }
        </div>
        <!-- Rows (iterator) -->
        @for (item of items; track item; let i = $index) {
                    <div class="
                        flex flex-row gap-4 items-center
                        px-6 py-3
                        border-b hover:bg-sky-50 dark:hover:bg-hover hover:cursor-pointer
                        md:px-8
                    " (click)="editItem(item)">
            @if (canModifyData) {
              <!-- Checkbox row -->
              <div>
                <mat-checkbox (click)="updateSelection(item, $event)" [checked]="item.selected" [disabled]="ordering">
                </mat-checkbox>
              </div>
            }
            <!-- Row data -->
            @for (column of columns; track column) {
              <div [ngClass]="{'text-clip overflow-auto whitespace-normal': !compact}"
                class="flex-1 truncate">
                @if (item.form?.fields?.[column.name]) {
                  <dtype-item
                    [field]="item.form.fields[column.name]" [useSummaryView]="true">
                  </dtype-item>
                }
              </div>
            }
            @if (masterData?.typology === 'LOCATION') {
              <div>
                @if (isLocationPending(item._oid)) {
                  <button mat-icon-button (click)="openChangeLocationModal($event, item)" [matTooltip]="'changeLocationTooltip' | transloco">
                    <mat-icon [svgIcon]="'mat_outline:pending_actions'"></mat-icon>
                  </button>
                }
              </div>
            }
            @if (ordering) {
              <div class="flex flex-row">
                <button mat-icon-button (click)="moveRow($event, 'up', i)" [disabled]="i === 0">
                  <mat-icon [svgIcon]="'heroicons_outline:chevron-up'"></mat-icon>
                </button>
                <button mat-icon-button (click)="moveRow($event, 'down', i)" [disabled]="i === items.length - 1">
                  <mat-icon [svgIcon]="'heroicons_outline:chevron-down'"></mat-icon>
                </button>
              </div>
            }
          </div>
        }
        <!-- Paginator -->
        <mat-paginator [class.hidden]="ordering" [length]="pagination.length" [pageSize]="pagination.size" [pageIndex]="pagination.page"
        [pageSizeOptions]="pageSizeOptions" [showFirstLastButtons]="false"></mat-paginator>
      </div>
    }

  </div>
</ng-template>

<!-- Database Tables View -->
<ng-template #databaseView>
  <!-- Header -->
  <div class="z-10 relative flex flex-row items-center flex-0 w-full bg-gray-100 dark:bg-transparent">
    <div class="flex flex-col flex-auto items-center justify-start">
      <!-- Go to Buttons -->
      <div class="flex p-4 items-center justify-start w-full">
        <!-- Go to data view-->
        <button mat-raised-button class="mat-focus-indicator p-4 mat-stroked-button mat-button-base mr-4" (click)="changeView()">
          <mat-icon class="mat-icon notranslate icon-size-5 mat-icon-no-color" aria-hidden="true"[svgIcon]="'heroicons_solid:external-link'"></mat-icon>
          <span class="pl-1">{{ 'data' | transloco}}</span>
        </button>
        <!-- Go to design -->
        @if (repo && repo.status !== 'STATIC') {
          <button mat-raised-button class="mr-4"
            [routerLink]="['../design']" [queryParams]="params" (click)="changeView()" [disabled]="repo?.locked && repo?.dtypeToGoLiveRequest">
            <mat-icon class="mat-icon notranslate icon-size-5 mat-icon-no-color" aria-hidden="true"[svgIcon]="'heroicons_solid:external-link'"></mat-icon>
            <span class="pl-1">{{ 'design' | transloco }}</span>
          </button>
        }

        <!-- Go to summary-->
        <button mat-raised-button class="mr-4" [routerLink]="['../summary']" [queryParams]="params" (click)="changeView()">
          <mat-icon class="mat-icon notranslate icon-size-5 mat-icon-no-color" aria-hidden="true"[svgIcon]="'heroicons_solid:external-link'"></mat-icon>
          <span class="pl-1">{{ 'summary' | transloco }}</span>
        </button>
      </div>
    </div>
  </div>

  <div class="flex flex-col flex-auto flex-shrink-0 lg:flex-shrink p-3 lg:overflow-y-auto bg-gray-100 dark:bg-transparent"
    fuseScrollReset>
    <database-table-view [data]="repo" [uri]="uri" [dtypeLocator]="dtypeLocator"></database-table-view>
  </div>
</ng-template>